import { render, staticRenderFns } from "./detailVendor.vue?vue&type=template&id=4afee88c&"
import script from "./detailVendor.vue?vue&type=script&lang=js&"
export * from "./detailVendor.vue?vue&type=script&lang=js&"
import style0 from "./detailVendor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports